import { Navigate, useLocation } from 'react-router-dom';

/**
 * A route redirect that survives AccountContextProvider canonicalising the URL (Bug #20888).
 *
 * A plain `<Navigate>` fires once, when it mounts. If the account scope has already resolved when
 * the user lands on the redirect route, the provider's canonicalise effect commits in the same pass
 * — after the redirect, and with the stale location — and replaces the URL with
 * `{old path}?account=…`. The route element is the same instance, so a plain `<Navigate>` never
 * fires again and the user is left on a blank page.
 *
 * Keying on `location.key` remounts the redirect whenever the location changes, so the
 * canonicalised URL is redirected in turn; carrying `search` over means the `?account=` the
 * provider added (or that was already there) survives, and the provider has nothing left to
 * rewrite on the target.
 */
export function RedirectPreservingSearch({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate key={location.key} to={{ pathname: to, search: location.search }} replace />;
}
